import React, { useRef } from 'react';
import { PiX } from 'react-icons/pi';
import useModalA11y from '../../hooks/useModalA11y';

// Full-screen click-to-expand viewer — click any thumbnail-sized image
// anywhere it's wired up and see it at real size instead of squinting at a
// small preview.
export default function ImageLightbox({ src, alt = 'Expanded image', onClose }) {
  const panelRef = useRef(null);
  useModalA11y(panelRef, onClose, !!src);

  // A drag that starts on the image (e.g. an attempted pan) can end with the
  // mouse released off the image — closing on that click alone would treat
  // the drag as a dismiss click. Requiring mousedown to have ALSO started on
  // the backdrop itself tells the two apart.
  const mouseDownOnBackdrop = useRef(false);

  if (!src) return null;

  return (
    <div
      ref={panelRef}
      tabIndex={-1}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 p-6 outline-none"
      onMouseDown={(e) => { mouseDownOnBackdrop.current = e.target === e.currentTarget; }}
      onClick={(e) => {
        if (mouseDownOnBackdrop.current && e.target === e.currentTarget) onClose();
        mouseDownOnBackdrop.current = false;
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Expanded image"
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20"
        aria-label="Close"
      >
        <PiX size={20} aria-hidden="true" />
      </button>
      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        className="max-h-full max-w-full rounded-lg object-contain shadow-2xl"
      />
    </div>
  );
}
